export const LegalTexts = () => {
	return (
		<div className="legal_texts">
			<p>Responsable del tratamiento: RALARSA, S.A. (CIF A12345678)</p>
			<p>
				Contacto:{" "}
				<a href="mailto:privacidad@ralarsa.es">privacidad@ralarsa.es</a>{" "}
				/ +34 900 123 456
			</p>
			<p>
				Finalidad: gestionar tu solicitud de cita y contactarte para su
				confirmación.
			</p>
			<p>
				Base jurídica: consentimiento del interesado (art. 6.1 a) RGPD.
			</p>
			<p>
				Destinatarios : no se cederán datos a terceros, salvo obligación
				legal.
			</p>
			<p>
				Derechos: tienes derecho a acceder, rectificar, suprimir,
				limitar y oponerte al tratamiento, así como a la portabilidad de
				tus datos y a retirar tu consentimiento en cualquier momento sin
				que ello afecte la licitud del tratamiento previo.
			</p>
			<p>
				Reclamaciones : puedes presentar una reclamación ante la{" "}
				<a
					href="https://www.aepd.es/"
					target="_blank"
					rel="noopener noreferrer"
				>
					AEPD
				</a>
			</p>
			<p>
				Más información : consulta la{" "}
				<a
					href="https://www.ralarsa.com/es/privacidad/"
					target="_blank"
					rel="noopener noreferrer"
				>
					política de privacidad
				</a>
			</p>
		</div>
	);
};
